import React, {useEffect, useRef,useState } from "react"; 
import {  useParams } from "react-router-dom";
import {getGameDetails,updateGameStatus} from "../../../Services/gameServices"
import GameFileUpdate from "./gameFileUpdate"
import GameBannersUpdate from "./gameBannersUpdate"
import { toast } from 'react-toastify'; 
import GameDetailsUpdate from "./gameDetailsUpdate"
import { useNavigate } from "react-router-dom";
import './gameList.css'
const GameDetailView = () => { 
    const { game_id } = useParams();
    const [gameData,setGameData]=useState({})
    const [render,setRender]=useState(false)
    const [disabled,isDisabled]=useState(false)
    useEffect(()=>{
        getGameDetails(game_id).then((data)=>{
            if(data.status){
                setGameData(data.data)
            }
        }) 
    },[render])
    const rerender=()=>{
        setRender(!render)
    }
    const navigate = useNavigate();

    const updateStatus = async (status, id) => {
        isDisabled(true)
        try { 
            const data = await updateGameStatus({ game_id: id, status });   
            isDisabled(false) 
            if (data?.status) {
                toast.success('Game status updated successfully')
                rerender();
            } else {
                alert('Something went wrong');
            }
        } catch (error) {
            isDisabled(false)
            console.error('Error updating game status:', error);
            alert('An error occurred while updating the status');
        }
    };
    
  return (
    <div>
   <main id="main" className="main"> 
      <section className="section">
         <div className="row"> 
         <div className="container custom-width">
        <div className="pagetitle">
            <h1>Game View</h1>
            <nav>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item cursor-pointer" onClick={()=>{navigate('/')}}>Home</li>
                    <li className="breadcrumb-item cursor-pointer" onClick={()=>{navigate('/games/gamelist')}}>Games list</li>
                    <li className="breadcrumb-item">Game view</li>
                </ol>
            </nav>
        </div>
        {/* End Page Title */}
 
            <div className="row">
                <div className="col-lg-12">
                    <div className="card">
                        <div className="card-body">
                        <div className="row">
                    <label className="col-sm-3 col-form-label">Subject</label>
                    <div className="col-lg-9 col-md-8" >: {gameData?.gamelevel?.gamesubject?.subject}</div>
                  </div>
                  <div className="row  g-3">
                    <label className="col-sm-3 col-form-label">Category</label>
                    <div className="col-lg-9 col-md-8" >: {gameData?.gamelevel?.category}</div>
                  </div>
                  <div className="row  g-3">
                    <label className="col-sm-3 col-form-label">Name</label>
                    <div className="col-lg-9 col-md-8" >: {gameData?.name}</div>
                  </div>
                  <div className="row  g-3">
                    <label className="col-sm-3 col-form-label">Description</label>
                    <div className="col-lg-9 col-md-8"  >: {gameData?.description}</div>
                  </div>
                  <div className="row  g-3">
                    <label className="col-sm-3 col-form-label">Game File</label>
                    <div className="col-lg-9 col-md-8" >: {gameData?.gamekeys?.[0]?.gamefile}</div>
                  </div> 
                        </div>
                    </div>
                    <div className="card">
                        <div className="card-body">
                            <h5 className="card-title">Game Details</h5>
                            <div className="accordion" id="accordionExample"> 
                                {/* Game file */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingOne">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseOne" aria-expanded="false" aria-controls="collapseOne">
                                            Game file
                                        </button>
                                    </h2>
                                    <div id="collapseOne" className="accordion-collapse collapse" aria-labelledby="headingOne" data-bs-parent="#accordionExample">
                                        <GameFileUpdate game_id={game_id} rerender={rerender}/>
                                    </div>
                                </div>

                                {/* Game banners */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingTwo">
                                        <button className="accordion-button collapsed" type="button" data-bs-toggle="collapse" data-bs-target="#collapseTwo" aria-expanded="false" aria-controls="collapseTwo">
                                            Game banners
                                        </button>
                                    </h2>
                                    <div id="collapseTwo" className="accordion-collapse collapse" aria-labelledby="headingTwo" data-bs-parent="#accordionExample">
                                       <GameBannersUpdate  game_id={game_id} />
                                    </div>
                                </div>

                                {/* Game details */}
                                <div className="accordion-item">
                                    <h2 className="accordion-header" id="headingThree">
                                        <button className="accordion-button collapsed" id="gameDetails" type="button" data-bs-toggle="collapse" data-bs-target="#collapseThree" aria-expanded="false" aria-controls="collapseThree">
                                            Game details
                                        </button>
                                    </h2>
                                    <div id="collapseThree" className="accordion-collapse collapse" aria-labelledby="headingThree" data-bs-parent="#accordionExample">
                                        <div className="row" style={{ width: '100%', margin: 0 }}>
                                        {gameData?.name &&  <GameDetailsUpdate game_id={game_id} gameData={gameData} rerender={rerender}/>}  
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div> 
            
        <div className="text-end mb-3">
       
          {gameData?.status==='DRAFT' &&  <button disabled={disabled} type="button" id="gameapprove" onClick={()=>{updateStatus('PUBLISHED',gameData?.id)}}  className="btn btn-primary">Approve</button>}  
          {gameData?.status!=='DRAFT' &&  <button  disabled={disabled}  type="button" id="gamedraft"  onClick={()=>{updateStatus('DRAFT',gameData?.id)}} className="btn btn-primary">Status Change To Draft</button>}  
            
        </div>
         
    </div>
</div>
</section>
</main>  
</div>
  );
};

export default GameDetailView;